import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import DocsList from '@/components/doc/DocsList.vue';
import PanelLayout from '@/components/PanelLayout.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PanelLayout, null, {
      default: _withCtx(() => [
        _createVNode(_component_RouterView),
        _createVNode(DocsList)
      ]),
      _: 1
    })
  ]))
}
}

})